import { render } from "./LeadsView.vue?vue&type=template&id=47d8f582&scoped=true"
import script from "./LeadsView.vue?vue&type=script&lang=js"
export * from "./LeadsView.vue?vue&type=script&lang=js"

import "./LeadsView.vue?vue&type=style&index=0&id=47d8f582&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47d8f582"]])

export default __exports__